import { ArrowRight } from "lucide-react";
import { CONTACT, IMAGES } from "@/data/content";
import { MaskedLines, Reveal } from "./Reveal";

export const Verification = () => (
  <section id="verification" className="section section-cream verification" data-testid="verification-section">
    <div className="verification-grid">
      <div>
        <Reveal>
          <p className="mono-label accent">04 / Authorisation &amp; Verification</p>
        </Reveal>
        <MaskedLines as="h2" className="section-title" lines={["Buy with"]} data-testid="verification-title" />
        <MaskedLines as="h2" className="section-title serif-italic" delay={0.12} lines={["confidence."]} />
        <Reveal delay={0.2}>
          <p className="lead" data-testid="verification-copy">
            AP Enterprises is the authorised JIC Hydraulics distributor in India.
            To help customers verify their source, we publish our distributor
            certificate and master distributor award.
          </p>
          <div className="callout" data-testid="verification-callout">
            <strong>Important:</strong> Counterfeit JIC components are being sold
            in India. Before placing an order, verify the supplier's authorisation
            or the part's source directly with AP Enterprises — call{" "}
            <a href="tel:+919739402645">+91 97394 02645</a>.
          </div>
          <a
            href={`mailto:${CONTACT.emails[0]}?subject=JIC authorisation verification`}
            className="link-underline"
            data-testid="verification-link"
          >
            Verify a JIC enquiry with us <ArrowRight size={18} />
          </a>
        </Reveal>
      </div>

      <div className="cert-stack">
        <Reveal delay={0.1} className="cert cert-a" data-testid="cert-distributor">
          <img src={IMAGES.certDistributor} alt="JIC Distributor Certificate" loading="lazy" />
          <span className="mono-label">JIC Distributor Certificate</span>
        </Reveal>
        <Reveal delay={0.25} className="cert cert-b" data-testid="cert-award">
          <img src={IMAGES.certAward} alt="Authorised Master Distributor Award" loading="lazy" />
          <span className="mono-label">Authorised Master Distributor Award</span>
        </Reveal>
      </div>
    </div>
  </section>
);
